import React from "react";
import { CheckCircle2, AlertTriangle } from "lucide-react";
import { Pill, num } from "../pipeline/Layer";
import { LevelPill, SilverBadge } from "./parts";
import { cn } from "../../lib/utils";

const slug = (s) => s.replace(/\s+/g, "-").toLowerCase();

function Module({ p, onOpen }) {
  const ok = p.required_missing === 0;
  return (
    <div className="tile overflow-hidden" data-testid={`std-pre-${slug(p.module)}`}>
      <div className="px-4 py-3 border-b border-border flex flex-wrap items-center gap-2">
        {ok ? <CheckCircle2 size={14} className="text-success" /> : <AlertTriangle size={14} className="text-warning" />}
        <div className="flex-1 min-w-0"><div className="font-semibold text-[13.5px]">{p.module}</div><div className="text-[11.5px] text-muted">{p.purpose}</div></div>
        <span className="text-[11.5px] font-mono-tabular text-muted" data-testid={`std-pre-${slug(p.module)}-count`}>{p.ready} of {p.total} tables in Silver</span>
        {!ok && <Pill tone="critical" testid={`std-pre-${slug(p.module)}-gap`}>{p.required_missing} required missing</Pill>}
      </div>
      <table className="w-full text-[12px]">
        <thead><tr className="text-[10px] uppercase tracking-widest text-muted">{["Table", "Needed", "Min. history", "Status"].map(h => <th key={h} className="text-left px-4 py-1.5 border-b border-border font-semibold">{h}</th>)}</tr></thead>
        <tbody>{p.tables.map(r => (
          <tr key={r.table} className={cn("border-b border-border/60", r.state === "missing" && r.level === "required" && "bg-critical/5")} data-testid={`std-pre-${slug(p.module)}-${r.table}`}>
            <td className="px-4 py-1.5"><button onClick={() => onOpen(r.table)} className="text-primary hover:underline text-left">{r.label}</button></td>
            <td className="px-4 py-1.5"><LevelPill level={r.level} /></td>
            <td className="px-4 py-1.5 font-mono-tabular">{r.days ? `${num(r.days)} days` : "—"}</td>
            <td className="px-4 py-1.5"><SilverBadge s={r.silver} need={r.days} /></td></tr>))}</tbody>
      </table>
    </div>
  );
}

// Prerequisites by module: the tables each module needs, required vs optional, minimum history and live in-Silver status.
export default function Prerequisites({ data, onOpen }) {
  return (
    <div className="space-y-4 animate-fade-in" data-testid="std-prereq">
      <div className="tile p-5"><h2 className="font-display text-lg font-semibold tracking-tight">Prerequisites by module</h2>
        <p className="text-[12.5px] text-muted mt-1 max-w-3xl">What each module needs before its insights run on your data. Status comes from the tables in Silver right now and updates as files are promoted.</p></div>
      <div className="grid xl:grid-cols-2 gap-4">{data.prerequisites.map(p => <Module key={p.module} p={p} onOpen={onOpen} />)}</div>
    </div>
  );
}
